import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">

      <div className="hero-bg-name">
        <span className="name-part left">DEEPAK</span>
        <span className="name-part right">KUMAR</span>
      </div>

      <div className="hero-image-wrapper">
        <img src="/dk.png" alt="Deepak Kumar" className="hero-photo" />
      </div>

      <div className="hero-content">
        <p className="hero-role">
          Content Writer<span></span> Graphic Designer
        </p>
        <div className="hero-divider"></div>
        <a href="#projects" className="accent-link">Explore my projects →</a>
      </div>

      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
      </div>

    </section>
  );
};

export default Hero;